export enum EFilterValueType {
    text = 'text',
    number = 'number',
    date = 'date'
}